import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import CartItemExpiration from '@/components/CartItemExpiration'
import { isBulkOrBulkIntegrationEnabledSelector } from '@/selectors'
import variantFactory from '@/utils/factory/variant/variantFactory'

const CART_ITEM_VARIANT = 'CartItemVariant'

const ItemDetails = ({ asset, price, variant }) => {
  const {
    daysLeftInLicense,
    edition,
    isOnlineResource,
    isSubscription,
    subtitle,
    title
  } = asset

  const cartItemVariant = variantFactory.createVariant(
    CART_ITEM_VARIANT, {
    daysLeftInLicense,
    isOnlineResource,
    isSubscription,
    variant
  })
  const isBulkOrBulkIntegrationEnabled = useSelector(
    isBulkOrBulkIntegrationEnabledSelector
  )

  return (
    <>
      <div className='cart-item-edit__item-details'>
        <div className='u-margin-bottom'>
          <p className='u-weight--bold'>{title}</p>
          <If condition={subtitle}>
            <p className='font-5'>{subtitle}</p>
          </If>
          <If condition={edition}>
            <p className='font-5'>
              <FormattedMessage id='common.edition_colon' />{edition}
            </p>
          </If>
        </div>
        <div role='status'>
          <CartItemExpiration {...{ cartItemVariant }} />
          <If condition={isBulkOrBulkIntegrationEnabled}>
            <p className='font-5'>
              <FormattedMessage id='carts.item_price' />{': '}
              {price}
            </p>
          </If>
        </div>
      </div>
    </>
  )
}

ItemDetails.propTypes = {
  asset: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  variant: PropTypes.object.isRequired,
}

export default ItemDetails
